export default {
  title: {
    welcome: 'Immagine bonus benvenuto',
    app_signup: 'Immagine bonus iscrizione app mobile',
  },
  select: {
    generate_title: "Genera un'immagine con l'IA",
    generate_subtitle: 'Ne creeremo una in base al tuo programma cashback.',
    generate_cta: 'Genera',
    upload_link: 'o carica dal tuo dispositivo',
    rate_limit_company: {
      title: 'Abbiamo bisogno di un momento',
      description: "Il tuo ristorante ha generato molte immagini nell'ultima ora. Riprova tra {{time}}.",
    },
    rate_limit_cashback_bonus: {
      title: 'Un breve momento di pausa',
      description: 'Hai provato questo bonus troppe volte di fila. Saremo pronti di nuovo tra {{time}}.',
    },
  },
  generating: {
    title: 'Generazione immagine in corso…',
    progress: {
      cooking: 'Stiamo preparando qualcosa di gustoso…',
      plating: 'Impiattamento…',
      finishing: 'Aggiungendo i tocchi finali…',
    },
  },
  preview: {
    alt: 'Immagine bonus generata',
    hint: "Non è giusta? Rigenera, o continua a ritagliare l'immagine.",
    click_to_expand: 'Clicca per espandere',
    regenerate: 'Rigenera',
    continue: 'Continua a modificare',
  },
  toasts: {
    upload_success: 'Immagine caricata con successo.',
    upload_failed: 'Caricamento immagine fallito.',
    delete_success: 'Immagine eliminata con successo.',
    delete_failed: 'Eliminazione immagine fallita.',
    generate_success: 'Immagine generata con successo.',
    generate_failed: 'Avvio generazione immagine fallito.',
    generate_timeout: "L'immagine è ancora in generazione. Apparirà qui quando pronta.",
    rate_limit_company: 'Limite orario immagini raggiunto per questo ristorante. Riprova tra {{time}}.',
    rate_limit_cashback_bonus: 'Troppi tentativi per questo bonus — riprova tra {{time}}.',
  },
  time: {
    seconds_one: '1 secondo',
    seconds_other: '{{count}} secondi',
    minutes_one: '1 minuto',
    minutes_other: '{{count}} minuti',
    hours_one: '1 ora',
    hours_other: '{{count}} ore',
  },
};
